import React, { useContext, useState } from 'react'
import { ModalContext } from 'providers/Modal'
import 'styles/revisedBeginForm.scss'

const RevisedBeginForm = props => {
  const { setActive } = useContext(ModalContext)
  const [selctedPostedBy, onChangePostedBy] = useState('Self')

  return (
    <div className="formWrap">
      <form>
        <div className="form-row">
          <label className="formLabel">
            I'm looking for a life partner for...
          </label>
          <div
            className={`postedBySelf ${
              selctedPostedBy === 'Self' ? 'markVisible' : 'markBlurred'
            }`}
            onClick={() => onChangePostedBy('Self')}
          >
            <input
              type="radio"
              name="beginpostedby"
              id="beginpostedby_self"
              value="Self"
              checked={selctedPostedBy === 'Self'}
            />
            <label className="postedbyLabel">Myself</label>
          </div>
          <div
            className={`postedByFamily ${
              selctedPostedBy === 'Family' ? 'markVisible' : 'markBlurred'
            }`}
            onClick={() => onChangePostedBy('Family')}
          >
            <input
              type="radio"
              name="beginpostedby"
              id="beginpostedby_family"
              value="Family"
              checked={selctedPostedBy === 'Family'}
            />
            <label className="postedbyLabel">Family or Friend</label>
          </div>
          <div className="buttonWrap">
            <button
              data-testid="lets_begin"
              type="button"
              onClick={() => setActive('register')}
              className="btn-primary form-control"
            >
              Let's Begin
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default RevisedBeginForm
